import { divisor, maxDisplayWidth } from "@/constants/runtime.config";
import { _css } from "@/utils/dom";

function flexible(window: Window & typeof globalThis, document: Document) {
  // 尝试从Android接口直接获取设备信息（方式1），否则使用已缓存的信息（方式2）
  // 更新布局的函数
  function updateLayout() {
    _css(document.documentElement, "max-width", maxDisplayWidth + "px");
    _css(document.documentElement, "font-size", Math.min(maxDisplayWidth, window.innerWidth) / divisor + "px");

    // 更新body字体大小
    if (document.body) {
      _css(document.body, "font-size", "14px");
    }
  }

  // 初始设置
  updateLayout();
  const dpr = window.devicePixelRatio || 1;
  // 设置字体大小
  function setBodyFontSize() {
    if (document.body) {
      _css(document.body, "font-size", "14px");
    } else {
      document.addEventListener("DOMContentLoaded", setBodyFontSize);
    }
  }

  // 设置rem单位
  function setRemRootFontSize() {
    _css(document.documentElement, "font-size", Math.min(maxDisplayWidth, window.innerWidth) / divisor + "px");
  }

  // 重置rem单位
  window.addEventListener("resize", () => {
    setRemRootFontSize();
    setBodyFontSize();
  });
  window.addEventListener("pageshow", function (e: { persisted: any }) {
    if (e.persisted) {
      setRemRootFontSize();
      setBodyFontSize();
    }
  });

  // 检测0.5px支持
  if (dpr >= 2) {
    const fakeBody = document.createElement("body");
    const testElement = document.createElement("div");
    testElement.style.border = ".5px solid transparent";
    fakeBody.appendChild(testElement);
    document.documentElement.appendChild(fakeBody);
    if (testElement.offsetHeight === 1) {
      document.documentElement.classList.add("hairlines");
    }
    document.documentElement.removeChild(fakeBody);
  }
}
flexible(window, document);
